import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles (theme => (
        {
            paginationPedidos: {
                float:'right',
                '& span': {
                    cursor: 'pointer',
                    float: 'left',
                    padding: '10px',
                    width: '40px',
                    height: '40px',
                    textdecoration: 'none',
                    textAlign: 'center',
                    transition: 'background-color .2s',
                    '&:active': {
                        background: theme.palette.secondary.main,
                        fontWeight: 'bold',
                        color: theme.palette.text.secundary,
                        borderRadius: '50%',
                    }
                },
            },
            active:{
                background: theme.palette.secondary.main,
                color: theme.palette.text.secundary,
                fontWeight: 'bold',
                borderRadius: '50%',
                cursor: 'pointer',
                float: 'left',
                padding: '10px',
                width: '35px',
                height: '35px',
                textAlign: 'center',
            },
        }
    ));
}